<p-toast position="{{smallScreen ? 'bottom-right' : 'bottom-right'}}"></p-toast>

<p-confirmDialog #cd>
  <p-footer>
    <button type="button" pButton icon="pi pi-check" class="p-button-raised" label="Yes" (click)="cd.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cd.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div style="height:100%;">
  <p-toolbar>
    <div class="p-toolbar-group-left">
      <!-- Display breadcrumb only on bigger than md screens-->
      <p-breadcrumb [model]="items" class="p-d-none p-d-md-inline"></p-breadcrumb>

      <div style="padding-top:2px;">
        <button pButton type="button" 
                class="p-button-rounded p-button-text p-button-primary button-icon-bold icon-large" 
                icon="pi pi-fw pi-refresh" 
                (click)="loadEmployeeTrainingRecords()"></button>

        <!-- Display only on bigger than md screens-->
        <div class="p-d-none p-d-md-inline">
          <button *ngIf="canManageEmployeeTrainingRecord()"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  label="Add Training Record" 
                  icon="pi-fw fas fa-user-graduate"
                  (click)="openEmployeeTrainingRecordForm(null)"></button>

          <button *ngIf="canManageEmployeeTrainingRecord()"
                  (click)="openEmployeeTrainingRecordForm(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button p-button-text" 
                  label="Edit Training Record" 
                  icon="pi-fw fas fa-user-edit"></button>
        </div>

        <!-- Display only on smaller than md screens-->
        <span class="p-d-md-none">
          <button *ngIf="canManageEmployeeTrainingRecord()" pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-user"
                  (click)="openEmployeeTrainingRecordForm(null)"></button>

          <button *ngIf="canManageEmployeeTrainingRecord()" 
                  (click)="openEmployeeTrainingRecordForm(selectedRow)"
                  [disabled]="selectedRow === null"
                  pButton type="button" 
                  class="p-button-rounded p-button-success" 
                  icon="pi-fw fas fa-user-edit"></button>
        </span>
      </div>
    </div>

    <div class="p-toolbar-group-right">
      <i class="pi-fw far fa-bell p-mr-4 p-mt-2 p-text-secondary toolbar-badge-icon text-success" pBadge 
         style="color: var(--green-600)" 
         severity="success"
         pTooltip="Total Number of Training Records: {{employeeTrainingRecords.length}}"
         value="{{employeeTrainingRecords.length}}"></i>
    </div>
  </p-toolbar>

  <div style="height: calc(100% - 36px)">
    <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                 size="default"
                 color="#2f9cf2"
                 type="line-scale-pulse-out"
                 [name]="spinnerName"
                 [fullScreen]="false"><p style="color:white" >Loading employees's training record... </p></ngx-spinner>
    <ag-grid-angular 
                      style="width: 100%; height:100%;"
                      class="ag-theme-alpine"
                      [rowData]="employeeTrainingRecords"
                      [columnDefs]="gridHeaders"
                      [context]="context"
                      [gridOptions]="gridOptions"
                      rowSelection="single"
                      (rowDoubleClicked)='onRowDblClicked($event)'
                      (rowClicked)='onRowClicked($event)'
                      (gridReady)="onGridReady($event)">
    </ag-grid-angular>  
  </div>
</div>
